import Head from '@/siteBuilder/components/Head/Head'
import Layout from '@/blogBuilder/components/Layout'
import ArticleProvider from '@/blogBuilder/provider/ArticleProvider'
import { GenericBlogProps } from '@/blogBuilder/utils/types/theme'
import Breadcrumbs from '@/siteBuilder/blocks/core/Breadcrumbs/Breadcrumbs'
import { getBreadcrumbData } from '@/blogBuilder/utils/breadcrumbSlugs'
import { Box } from '@telus-uds/components-web'
import Preview from '@/blogBuilder/components/Preview'
import HeroBanner from '@/blogBuilder/components/HeroBanner/Blog'
import Categories from '@/blogBuilder/components/Categories/Blog'
import { TypeSeoTagsFields, TypeSeoTagsWithoutUnresolvableLinksResponse } from '@/contentful-types'
import { filterTags } from '@/blogBuilder/utils/types/theme'

const Blog = ({ genericBlogTemplate, locale, breadcrumbs, fullBlogUrls }: GenericBlogProps) => {
  const categoriesCollection = genericBlogTemplate.categories.filter((category) => category.fields)
  const isCategorySeparationDisabled = genericBlogTemplate?.isCategorySeparationDisabled
  const slugsToRender = getBreadcrumbData(breadcrumbs, locale.language)

  const articles = categoriesCollection.filter((category) => category.fields.articles)

  const filterTags = genericBlogTemplate.categories
    .flatMap((category) => {
      return { tags: category?.fields?.filterTags, category: category?.fields?.name }
    })
    .filter((d) => d) // Added missing comma here

  const filterTagsWithAll: { tags: filterTags; category: string }[] = genericBlogTemplate?.filterTags
    ? [...filterTags, { tags: genericBlogTemplate.filterTags, category: 'All' }]
    : filterTags

  return (
    <Layout hasGreyBackground={false}>
      <Head
        title={genericBlogTemplate?.seo?.fields?.metaTitle}
        language={locale.language}
        seo={genericBlogTemplate.seo?.fields as unknown as TypeSeoTagsWithoutUnresolvableLinksResponse['fields']}
      />
      <ArticleProvider
        navigationOptions={genericBlogTemplate?.navigationOptions || 'Show More'}
        lang={locale.language}
        categories={categoriesCollection}
        {...{ isCategorySeparationDisabled }}
      >
        {breadcrumbs && <Breadcrumbs breadcrumbs={slugsToRender} />}
        <HeroBanner
          image={genericBlogTemplate.heroImage}
          imageMobile={genericBlogTemplate.heroImageMobile}
          title={genericBlogTemplate.title}
          description={genericBlogTemplate.description}
        />
        <Box vertical={3}>
          {!isCategorySeparationDisabled && <Categories lang={locale.language} />}
          {articles.length && (
            <Preview
              navigationOptions={genericBlogTemplate?.navigationOptions || 'Show More'}
              blogs={genericBlogTemplate.categories}
              lang={locale.language}
              fullBlogUrls={fullBlogUrls}
              theme="blog"
              filterTags={filterTagsWithAll}
            />
          )}
        </Box>
      </ArticleProvider>
    </Layout>
  )
}
export default Blog
